export default function IconGoogle({ className }: { className?: string }) {
  return (
    <svg
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={className}
    >
      <path
        d='M21.7508 12.2252C21.7508 11.5625 21.696 10.8961 21.579 10.2441H12.1973V13.9986H17.5698C17.3468 15.2094 16.6305 16.2806 15.5816 16.9613V19.3973H18.7868C20.669 17.6992 21.7508 15.1915 21.7508 12.2252Z'
        fill='#4285F4'
      />
      <path
        d='M12.197 21.7506C14.8796 21.7506 17.1419 20.8872 18.7902 19.3969L15.5849 16.9608C14.6932 17.5555 13.5419 17.8922 12.2006 17.8922C9.60575 17.8922 7.40559 16.1762 6.61616 13.8691H3.30859V16.3804C4.9971 19.6727 8.43623 21.7506 12.197 21.7506Z'
        fill='#34A853'
      />
      <path
        d='M6.61196 13.8692C6.19532 12.6584 6.19532 11.3472 6.61196 10.1363V7.625H3.30805C1.89732 10.3799 1.89732 13.6256 3.30805 16.3805L6.61196 13.8692Z'
        fill='#FBBC04'
      />
      <path
        d='M12.197 6.10897C13.615 6.08747 14.9856 6.61051 16.0126 7.57061L18.8523 4.78704C17.0542 3.13194 14.6676 2.222 12.197 2.25066C8.43623 2.25066 4.9971 4.32848 3.30859 7.62435L6.6125 10.1357C7.39828 7.82497 9.6021 6.10897 12.197 6.10897Z'
        fill='#EA4335'
      />
    </svg>
  )
}
